"use strict";

export default {
  namespaced: true,

  state: {
    currentSearchTerm: null,
    currentSearchTermOpenings: null
  },

  mutations: {
    setCurrentSearchTerm(state, payload) {
      state.currentSearchTerm = payload;
    },

    setCurrentSearchTermOpenings(state, payload) {
      state.currentSearchTermOpenings = payload;
    }
  },

  actions: {
    currentSearchTerm({ commit, dispatch }, payload) {
      commit("setCurrentSearchTerm", payload);

      dispatch("currentSearchTermOpenings");
    },

    currentSearchTermOpenings({ commit }) {
      const currentSearchTerm = this.getters["search/currentSearchTerm"],
        allOpenings = this.getters["openings/allOpenings"];

      let results = [];

      if (allOpenings) {
        for (let opening of allOpenings) {
          let termsToSearch = `${opening.title} ${opening.description}`;

          if (!termsToSearch.match(new RegExp(currentSearchTerm, "gi"))) continue;
          else results.push(opening);
        }
      }

      commit("setCurrentSearchTermOpenings", results);
    }
  },

  getters: {
    currentSearchTerm(state) {
      return state.currentSearchTerm;
    },

    currentSearchTermOpenings(state) {
      return state.currentSearchTermOpenings;
    }
  }
};
